/* eslint-disable no-shadow */
/* eslint-disable @typescript-eslint/naming-convention */
import { BusinessModel, FileModel } from '..';
import { FinishedProductModel } from './finishedProduct';

export enum EPriceType {
  PricePerUnit,
  PricePerSquareMeter,
  PricePerMeter,
  PricePer100Meter,
  PricePerKg,
}

export enum EAccountingType {
  Sale,
  Purchase,
}

export class PriceItem {
  public _id?: string;
  type: EPriceType;
  value: number;
  // minValue: number;
  currency: string;
  validFrom: Date;
  validTo: Date;
  disabled: boolean = false;
}

export class PriceMatrixModel {
  public _id?: string;

  issuer: number;
  business: BusinessModel;
  finishedProduct: FinishedProductModel;
  finishedProductCode: string;
  accounting: EAccountingType;
  price: PriceItem[];
  files: FileModel[];

}
